// extracted by mini-css-extract-plugin
module.exports = {"title":"AppNewsList_title__2Bg5o","appNewsCardTitle":"AppNewsList_appNewsCardTitle__1MCEF","appNewsCardSubtitle":"AppNewsList_appNewsCardSubtitle__1-ehJ"};